'use strict';

module.exports = function (array, iterator, done) {
    check(array, iterator, done);
    
    var i = -1;
    var n = array.length;
    
    var loop = function (e) {
       ++i;
       
       if (e || i === n)
           { return done(e); }
       
       iterator(array[i], loop);
    };
    
    loop();
}

function check(array, iterator, done) {
    if (!Array.isArray(array))
        { throw Error('array should be an array!'); }
    
    if (typeof iterator !== 'function')
        { throw Error('iterator should be a function!'); }
    
    if (typeof done !== 'function')
        { throw Error('done should be a function!'); }
}

